import Slider from "react-slick";
import "../styling/Services.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { FaNetworkWired, FaServer, FaSitemap, FaGlobe } from "react-icons/fa";

const iconMap = {
  "System Setup": <FaNetworkWired className="service-icon" />,
  "Full-Stack Web Development": <FaGlobe className="service-icon" />,
  "IT Troubleshooting & Diagnosis": <FaSitemap className="service-icon" />,
  "Website Administrator": <FaServer className="service-icon" />,
};


const servicesData = [
  {
    icon: iconMap["System Setup"],
    title: "System Setup",
    description:
      "Setting up and configuring systems like Network, CCTV, VoIP (PBX & GSM), access control, nurse call systems, and parking systems.",
  },
  {
    icon: iconMap["Full-Stack Web Development"],
    title: "Full-Stack Web Development",
    description:
      "Development of scalable web apps, CMS, and dashboards using Laravel, React, Node.js, and MongoDB, including role-based access control.",
  },
  {
    icon: iconMap["IT Troubleshooting & Diagnosis"],
    title: "IT Troubleshooting & Diagnosis",
    description:
      "Diagnosing and resolving issues related to IT infrastructure and system configurations.",
  },
  {
    icon: iconMap["Website Administrator"],
    title: "Website Administrator",
    description:
      "Managing, maintaining, and updating websites based on end-user preferences",
  },
];

const sliderSettings = {
  dots: true,
  arrows: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const Services = () => {
  return (
    <div id="services-section" className="services">
      <div className="services-header">
        <h5>Services</h5>
        <h1>What Can I Do For You?</h1>
      </div>
      <Slider {...sliderSettings} className="services-slider">
        {servicesData.map((service, index) => (
          <div key={index} className="service-card">
            <div className="service-card-inner">
              {service.icon}
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Services;
